import { CIVIL_CHECKLIST,FIRST_INTERACTION_FORM,CONFIGURATION_TESTING,VALET_GO_LIVE,DASHBOARD_TRAINING,DASHBOARD_TRAINING_CHK_DETAILS } from "./type";

const initalState = {
  civilData: {},
  firstInteractionForm: {},
  configAndTesting: {},
  valetGoLive:{},
  dashboardTraining: {},
  dashboardTrainingChecklist: {},
};

const civilReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case CIVIL_CHECKLIST:
      return {
        ...state,
        civilData: payload,
      };
    case FIRST_INTERACTION_FORM:
      return {
        ...state,
        firstInteractionForm: payload,
      };  
    case CONFIGURATION_TESTING:
      return {
        ...state,
        configAndTesting: payload,
      };
    case VALET_GO_LIVE:
      return {
        ...state,
        valetGoLive: payload,
      };  
    case DASHBOARD_TRAINING:
      return {
        ...state,
        dashboardTraining: payload,
      };
    case DASHBOARD_TRAINING_CHK_DETAILS:
      return {
        ...state,
        dashboardTrainingChecklist: payload,
      };  
    default:
      return {
        ...state,
      };
  }
};

export default civilReducer;
